'use client';

import { ReactNode } from 'react';

import {
  GET_ASSEMBLYAI_TOKEN,
  ProjectMode,
  ProjectType,
} from '@/survey-graphql';

import ProjectResponseContext from './shared-survey-project-response-mode.context';
import { useProjectResponseModeProvider } from './shared-survey-project-response-mode.hooks';

interface Props {
  children: ReactNode;
  getAssemblyAiTokenDocument?: typeof GET_ASSEMBLYAI_TOKEN;
  projectMode?: ProjectMode | null | undefined;
  projectType?: ProjectType | null | undefined;
}

export function ProjectResponseModeProvider({
  children,
  getAssemblyAiTokenDocument,
  projectMode = ProjectMode.Chat,
  projectType = ProjectType.Survey,
}: Props) {
  const contextValue = useProjectResponseModeProvider(
    getAssemblyAiTokenDocument,
    projectMode,
    projectType
  );
  return (
    <ProjectResponseContext.Provider value={contextValue}>
      {children}
    </ProjectResponseContext.Provider>
  );
}
